<template>
    <div class="form">
        <div class="form-section">
            <div class="form-section-heading">
                {{ trans('learning_contents.form.title.general') }}
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <label class="label">{{ trans('course_variations.label.tenant') }}</label>
                    <v-select id="tenant_select" v-model="selectedTenant"
                        :options="this.tenantSelectOptions"
                        @input="apiGetClients"
                        class="form-vue-select"
                        :disabled="disable"
                    >
                        <div slot="no-options">{{ trans('vue_select.no_options') }}</div>
                    </v-select>
                    <input type="hidden" name="tenant_ident" :value="selectedTenant.ident">
                </div>

                <div class="form-row__col form-row__col--one-half">
                    <label class="label">{{ trans('course_variations.label.client') }}</label>
                    <v-select id="client_select" v-model="selectedClient"
                        :options="this.clientSelectOptions"
                        class="form-vue-select"
                        :disabled="disable"
                    >
                        <div slot="no-options">{{ trans('vue_select.no_options') }}</div>
                    </v-select>
                    <input type="hidden" name="client_id" :value="selectedClient.value">
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="name"
                        :required="true"
                        v-model="form.name"
                        :placeholder="trans('learning_contents.form.placeholder.name')"
                    >
                        {{ trans('learning_contents.form.label.name') }}
                    </form-input>
                </div>

                <div class="form-row__col form-row__col--one-half">
                    <form-selectbox
                        v-model="form.type"
                        :required="true"
                        name="type"
                        :disabled="disable"
                        :options="[
                            {value: '', label:trans('learning_contents.form.select.default')},
                            {value: 'video', label:trans('learning_contents.form.select.type.video')},
                            {value: 'pdf', label:trans('learning_contents.form.select.type.pdf')},
                            {value: 'image', label:trans('learning_contents.form.select.type.image')},
                            {value: 'wbt', label:trans('learning_contents.form.select.type.wbt')},
                            {value: 'dlc', label:trans('learning_contents.form.select.type.dlc')},
                        ]"
                    >
                        {{ trans('learning_contents.form.label.type') }}
                    </form-selectbox>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="comment"
                        v-model="form.comment"
                        :placeholder="trans('learning_contents.form.placeholder.comment')"
                    >
                        {{ trans('learning_contents.form.label.comment') }}
                    </form-input>
                </div>
            </div>
        </div>

        <div class="form-section" v-if="show">
            <div class="form-section-heading">
                {{ trans('learning_contents.form.title.additional') }}
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-selectbox
                        v-model="form.reviewMode"
                        name="review_mode"
                        :options="[
                            {value: 1, label:trans('mail_reminder_configs.actions.activated')},
                            {value: 0, label:trans('mail_reminder_configs.actions.deactivated')},
                        ]"
                    >
                        {{ trans('learning_contents.form.label.review_mode') }}
                    </form-selectbox>
                </div>

                <div class="form-row__col form-row__col--one-half">
                    <form-selectbox
                        v-model="form.continueLearningMode"
                        name="continue_learning_mode"
                        :options="[
                            {value: 1, label:trans('mail_reminder_configs.actions.activated')},
                            {value: 0, label:trans('mail_reminder_configs.actions.deactivated')},
                        ]"
                    >
                        {{ trans('learning_contents.form.label.continue_learning_mode') }}
                    </form-selectbox>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-selectbox
                        v-model="form.credit"
                        name="credit"
                        :options="[
                            {value: 'credit', label:trans('learning_contents.form.select.credit.credit')},
                            {value: 'no_credit', label:trans('learning_contents.form.select.credit.no_credit')},
                        ]"
                    >
                        {{ trans('learning_contents.form.label.credit') }}
                    </form-selectbox>
                </div>

                <div class="form-row__col form-row__col--one-half">
                    <form-selectbox
                        v-model="form.lessonMode"
                        name="lesson_mode"
                        :options="[
                            {value: 'normal', label:trans('learning_contents.form.select.lesson_mode.normal')},
                            {value: 'preview', label:trans('learning_contents.form.select.lesson_mode.preview')},
                        ]"
                    >
                        {{ trans('learning_contents.form.label.lesson_mode') }}
                    </form-selectbox>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="character_set"
                        v-model="form.characterSet"
                    >
                        {{ trans('learning_contents.form.label.character_set') }}
                    </form-input>
                </div>
            </div>
        </div>

        <div class="form-section" v-if="form.type !== ''">
            <div class="form-section-heading">
                {{ trans('learning_contents.form.title.file') }}
            </div>

            <div class="form-row">
                <div class="form-row__col">
                    <alert type="info"> {{ downloadText }} </alert>
                </div>
                <div class="form-row__col">
                    <div class="file-upload">
                        <input type="file" name="file" id="file" @change="getFileName($event)" />
                        <label for="file">
                            <div class="label">{{ uploadedFileName || trans('learning_contents.form.label.file') }}</div>
                            <div class="icon-button icon-button--primary">
                                <div class="icon-button__icon">
                                    <img src="/images/icons/create.svg" alt="">
                                </div>
                            </div>
                            <span class="invalid-feedback">
                                <strong>{{ this.error|| this.errors('file') }}</strong>
                            </span>
                        </label>
                    </div>
                </div>

            </div>
        </div>

        <div class="form-section">
            <div class="form-section-heading">
                {{ trans('learning_contents.form.title.resubmit_at') }}
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        type="date"
                        name="resubmit_at"
                        v-model="form.resubmitAt"
                    >
                        {{ trans('learning_contents.form.label.date') }}
                    </form-input>
                </div>
            </div>
        </div>

        <div class="page-control">
            <div class="page-control__element">
                <button type="submit" class="btn btn--big btn--primary">{{ trans('buttons.submit') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            'learningContent' : {
                type: Object,
                default: () => { return {} }
            },
            'tenants' : {
                type: Array,
                default: []
            },
            'error': '',
            'fileName': ''
        },

        data() {
            return {
                selectedTenant: {label: this.trans('course_variations.label.all'), value: null, ident: null},
                selectedClient: {label: this.trans('course_variations.label.all'), value: null},
                clients: [],
                form: {
                    name: this.old('name', this.learningContent.name),
                    comment: this.old('comment', this.learningContent.comment),
                    type: this.old('type', this.learningContent.type),
                    resubmitAt: this.old('resubmit_at', this.learningContent.resubmit_at),
                    credit: this.old('credit', this.learningContent.credit || 'credit'),
                    characterSet: this.old('character_set', this.learningContent.character_set),
                    reviewMode: this.old('review_mode', this.learningContent.review_mode ? 1 : 0 || 0),
                    lessonMode: this.old('lesson_mode', this.learningContent.lesson_mode || 'normal'),
                    continueLearningMode: this.old('continue_learning_mode', this.learningContent.continue_learning_mode ? 1 : 0 || 0),
                },
                uploadedFileName: this.fileName
            }
        },

        computed: {
            downloadText() {
                return this.trans('learning_contents.form.description.file.' + this.form.type)
            },

            tenantSelectOptions() {
                var temp = this.tenants.map(tenant => {
                    return {label: tenant.tenant_name, value: tenant.id, ident: tenant.tenant_ident};
                });
                temp.unshift({label: this.trans('course_variations.label.all'), value: null, ident: null});
                return temp;
            },

            clientSelectOptions() {
                var temp = this.clients.map(client => {
                    return {label: client.name, value: client.id};
                });
                // var temp = [];
                temp.unshift({label: this.trans('course_variations.label.all'), value: null});
                return temp;
            },

            show() {
                return this.form.type === 'wbt'
            },

            disable() {
                return Object.keys(this.learningContent).length !== 0
            }
        },

        mounted() {
            // if learning content has tenant_ident in edit, overwrite the default
            if (this.learningContent.tenant_ident) {
                var filtered_tenant = this.tenants.filter(tenant => {
                    return tenant.tenant_ident == this.learningContent.tenant_ident;
                });
                this.selectedTenant = {label: filtered_tenant[0].tenant_name, value: filtered_tenant[0].id, ident: filtered_tenant[0].tenant_ident};

                // also update the client select list
                axios.post('/api/clients/getClientsFromTenant', {'tenant_ident': this.selectedTenant.ident}).then(response => {
                    this.clients = response.data;
                    // if learning content has client_id in edit, overwrite the default
                    if (this.learningContent.client_id) {
                        var filtered_client = this.clients.filter(client => {
                            return client.id == this.learningContent.client_id;
                        });
                        this.selectedClient = {label: filtered_client[0].name, value: filtered_client[0].id};
                    }
                });
            }
        },

        methods: {
            apiGetClients() {
                if (this.selectedTenant.ident == null) {
                    this.clients = [];
                    return;
                }
                axios.post('/api/clients/getClientsFromTenant', {'tenant_ident': this.selectedTenant.ident}).then(response => this.clients = response.data);
            },

            getFileName(event) {
                if (event) {
                    return this.uploadedFileName = event.target.files[0].name
                }
            }
        }
    }
</script>
